import { changeParentNode } from "../../commands/commands";
import { Extension } from "../../core/extension";
import { smallParagraphSpec } from "./schema";
export class SmallParagraphExtension extends Extension {
    addNodes(nodes) {
        return nodes.append(smallParagraphSpec());
    }
    addCommands(schema) {
        return {
            applyParagraphSmall: changeParentNode(schema.nodes.paragraph_small),
        };
    }
}
